module.exports = __webpack_public_path__ + "img/github.cb502f82.svg";